/**
 * API operations retrieved originally from the API itself.
 */
class ApiOperations {

    /**
     * Constructor.
     */
    constructor() {
        this.operations = new Map();
    }

    /**
     * Parse JSON representing a set of API operations.
     *
     * @param {Object.<string,Object.<string,Object>} json
     */
    parseJson(json) {
        for (const [path, item] of Object.entries(json)) {
            for (const method of Object.keys(item)) {
                this.operations.set(item[method].operationId, {
                    path:       path,
                    method:     method,
                    parameters: item[method].parameters || []
                });
            }
        }
    }

    /**
     * Render a URL path for an operation ID.
     *
     * @param {string} id - The operation ID to render.
     * @param {Object.<string, string>} params - A mapping of parameter names
     *     to parameter values.
     * @return {string}
     */
    render(id, params) {

        if (! id || ! this.operations.has(id)) {
            return;
        }

        const operation = this.operations.get(id);
        let href = operation.path;
        const query = [];

        for (let name in params) {

            const param = operation.parameters.find(p => p.name == name);

            if (param) {

                const value = params[name];

                switch (param.in) {
                    case 'path':
                        href = href.replace(`{${param.name}}`, value);
                        break;
                    case 'query':
                        query.push(`${name}=${value}`);
                        break;
                    default:
                        break;
                }
            }
        }

        if (query.length > 0) {
            href = `${href}?${query.join('&')}`;
        }

        return href;
    }
}

/**
 * A single global instance of API operations.
 */
export const apiOperations = new ApiOperations();
